import {getDatasource} from "@/datasource";
import {useRoute} from "vue-router";
import {onAppInit} from "@guizhuan/sylowcode-components";
import {ref, shallowRef, watch} from "vue";
import http from "@/utils/request";


let userPermission = shallowRef();

function getUserPermission() {
    // let api = getDatasource().create({
    //     url: `/modules/other`,
    //     method: 'GET',
    // });
    // api.run().then(res => {
    //     const tempData = res.data;
    //     let apiUserPermission = [];
    //     tempData.forEach((ele) => {
    //         const {
    //             moduleid,
    //             ...otherParams
    //         } = ele;
    //         apiUserPermission.push([moduleid, otherParams]);
    //     });
    //     userPermission.value = new Map(apiUserPermission);
    // })
    http.get(`/modules/other`).then(res=>{
        const tempData = res.data;
        let apiUserPermission = [];
        tempData.forEach((ele) => {
            const {
                moduleid,
                ...otherParams
            } = ele;
            apiUserPermission.push([moduleid, otherParams]);
        });
        userPermission.value = new Map(apiUserPermission);
    }).catch(()=>{

    })
}


onAppInit(() => {
    getUserPermission()
})

// 获取模块下权限
function getModulePermissionList(modulesId) {
    if (!modulesId || !userPermission.value) {
        getUserPermission()
        return {}
    }
    return userPermission.value.get(modulesId) || {};
}

export function useAuthorize() {
    const route = useRoute()
    if (!(route && route.meta && route.meta.F_Id)) {
        return null
    }

    let buttonEnCodeList = ref()
    let columnEnCodeList = ref()
    let formEnCodeList = ref()

    watch(userPermission, () => {
        const modulePermissionList = getModulePermissionList(route.meta.F_Id)
        buttonEnCodeList.value = modulePermissionList["button"]
        columnEnCodeList.value = modulePermissionList["column"]

        const formPermissionList = modulePermissionList["form"]
        const returnPermissionList = {};
        for (const key in formPermissionList) {
            if (Object.hasOwnProperty.call(formPermissionList, key)) {
                const val = formPermissionList[key];
                if (typeof val == 'object') {
                    for (const key2 in val) {
                        if (Object.hasOwnProperty.call(val, key2)) {
                            const element2 = val[key2];
                            returnPermissionList[key2] = element2;
                        }
                    }
                } else {
                    returnPermissionList[val] = val;
                }
            }
        }
        formEnCodeList.value = returnPermissionList
    }, {immediate: true})

    const hasButtonPermission = (encode) => {
        if (buttonEnCodeList.value && buttonEnCodeList.value.includes(encode)) {
            return true;
        } else {
            // return false;
			return true;
        }
    }

    const hasFormPermission = (encode) => {
        if (formEnCodeList.value && formEnCodeList.value[encode]) {
            return true;
        } else {
            // return false;
			return true;
        }
    }

    const getColumnEnCodeList = () => {
        if (!columnEnCodeList.value) {
            return []
        }
        return columnEnCodeList.value.map((ele) => {
            return ele.prop;
        });
    }

    const hasButtonPermissionEntity = (encode) => {
        if (buttonEnCodeList.value && buttonEnCodeList.value.includes(encode)) {
            return true;
        } else {
            return false;
        }
    }

    const hasFormPermissionEntity = (encode) => {
        if (formEnCodeList.value && formEnCodeList.value[encode]) {
            return true;
        } else {
            return false;
        }
    }
    return {hasButtonPermission, hasFormPermission, getColumnEnCodeList,hasButtonPermissionEntity,hasFormPermissionEntity,getUserPermission}
}

export function useFlowAuthorize(moduleId) {
    let buttonEnCodeList = ref()
    // let columnEnCodeList = ref()
    // let formEnCodeList = ref()

    watch(userPermission, () => {
        const modulePermissionList = getModulePermissionList(moduleId)
        buttonEnCodeList.value = modulePermissionList["button"]
        // columnEnCodeList.value = modulePermissionList["column"]

        // const formPermissionList = modulePermissionList["form"]
        // const returnPermissionList = {};
        // for (const key in formPermissionList) {
        //     if (Object.hasOwnProperty.call(formPermissionList, key)) {
        //         const val = formPermissionList[key];
        //         if (typeof val == 'object') {
        //             for (const key2 in val) {
        //                 if (Object.hasOwnProperty.call(val, key2)) {
        //                     const element2 = val[key2];
        //                     returnPermissionList[key2] = element2;
        //                 }
        //             }
        //         } else {
        //             returnPermissionList[val] = val;
        //         }
        //     }
        // }
        // formEnCodeList.value = returnPermissionList
    }, {immediate: true})

    // const hasButtonPermission = (encode) => {
    //     if (buttonEnCodeList.value && buttonEnCodeList.value.includes(encode)) {
    //         return true;
    //     } else {
    //         // return false;
	// 		return true;
    //     }
    // }

    // const hasFormPermission = (encode) => {
    //     if (formEnCodeList.value && formEnCodeList.value[encode]) {
    //         return true;
    //     } else {
    //         // return false;
	// 		return true;
    //     }
    // }

    // const getColumnEnCodeList = () => {
    //     if (!columnEnCodeList.value) {
    //         return []
    //     }
    //     return columnEnCodeList.value.map((ele) => {
    //         return ele.prop;
    //     });
    // }

    const hasButtonPermissionEntity = (encode,isShow) => {
        if (buttonEnCodeList.value && buttonEnCodeList.value.includes(encode)&&isShow) {
            return true;
        } else {
            return false;
        }
    }

    // const hasFormPermissionEntity = (encode) => {
    //     if (formEnCodeList.value && formEnCodeList.value[encode]) {
    //         return true;
    //     } else {
    //         return false;
    //     }
    // }
    // return {hasButtonPermission, hasFormPermission, getColumnEnCodeList,hasButtonPermissionEntity,hasFormPermissionEntity,getUserPermission}
    return {hasButtonPermissionEntity}
}
/**
 * @description 获取当前表单的权限
 * @param {string} moduleId moduleId
 * @return {Array} 返回当前表单的权限配置
 */
let list = []
export function formEditPermission(moduleId){
    list = []
    let arr = userPermission.value
    if(arr && arr.size >0){
        arr.forEach((value, key)=>{
            if(key === moduleId) list.push(value)
        })
    }
    return list
}